import { createSelector } from 'reselect';

const selectSingleNyhet = state => state.get('nyhetsingle');

const makeSelectNyhet = () =>
  createSelector(selectSingleNyhet, nyhetState => nyhetState.get('nyhet'));

export { selectSingleNyhet, makeSelectNyhet };
